import LoginRecover from 'pages/LoginRecover/styled';

export default LoginRecover;
